import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MasterDataService } from '../services/masterdata.service';
import { Subject } from 'rxjs';
import { SelectedCountry } from '../models/selected-country';
import { CountryList } from '../models/country-list';
import { takeUntil } from 'rxjs/operators';
import $ from "jquery";
import 'bootstrap';
import { Modal } from 'bootstrap';
@Component({
    selector: 'app-manage-mailbox',
    templateUrl: './manage-mailbox.component.html',
    styleUrls: ['./manage-mailbox.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ManageMailboxComponent implements OnInit {
    countries: Array<CountryList>;
    filteredCountries: Array<CountryList>;
    selectedCountry: string = 'Country_Location';
    countryDetailsSelected: SelectedCountry;
    private subscription: Subject<void> = new Subject<void>();
    @ViewChild('updateEmail') updatedEmail: ElementRef;
    sampleColumns: any;
    totalRecords: number;
    constructor(private masterDataService: MasterDataService) { }

    ngOnInit() {
        this.loadTableData();
        this.masterDataService.getMasterDataDetails().pipe(takeUntil(this.subscription)).subscribe(res => {
            this.countries = [];
            if (res && res.Countries && res.Countries.length > 0) {
                res.Countries.map(country => {
                    this.countries.push({
                        ID: country.ID, Name: country.Name,
                        BCMailBox: country.BCMailBox, IsDeloitte: country.IsDeloitte,
                    })
                });
                this.getFilteredCountryList(this.selectedCountry);
                this.relaodSavedCountry();
            }
        });
    }
    removeBackdrop() {
        const backdrop = document.querySelector('.modal-backdrop');
        if (backdrop) {
          backdrop.remove();
        }
      }

    getFilteredCountryList(selectedCountry: string, saveCountry?) { 
        if (selectedCountry && selectedCountry !== 'Country_Location') {
            this.filteredCountries = this.countries.filter(country => country.Name === selectedCountry);
        } else {
            this.filteredCountries = JSON.parse(JSON.stringify(this.countries));
        }
        this.totalRecords = (this.filteredCountries.length > 0) ? this.filteredCountries.length : 0;

        if (saveCountry) {
            this.masterDataService.countryForManageMailBox = this.selectedCountry;
        }
    }

    openUpdateEmailModal(id: number, name: string, email: string, isDeloitte: boolean | null) {
        this.countryDetailsSelected = {
            countryIdSelected: id,
            countryNameSelected: name,
            userEmailSelected: email,
            isDeloitteSelected: isDeloitte
        }
        const saved_search_Modal = new Modal(document.getElementById('saved_search_Modal'));
        saved_search_Modal.show();
        this.removeBackdrop();
        // $('#saved_search_Modal').modal({ backdrop: 'static', keyboard: false })
        // $("#saved_search_Modal").modal("show");
        // $('.modal-backdrop').remove();
    }

    updateEmail(event) {
        this.countries.map(country => {
            if (country.ID === event.CountryId) {
                country.BCMailBox = event.NewCountryMailbox;
            }
        });
        this.getFilteredCountryList(this.selectedCountry);

        if (event.CountryId && event.NewCountryMailbox) {
            this.masterDataService.masterData.Countries.map(data => {
                if (data.ID === event.CountryId) {
                    data.BCMailBox = event.NewCountryMailbox;
                }
            });
        }
    }

    loadTableData() {
        this.sampleColumns = [
            { name: "Name", header: "Country/Location", dataType: "string", minWidth: "60px" },
            { name: "BCMailBox", header: "Mailbox", dataType: "string", minWidth: "200px" }
        ];
    }

    onRowSelect(event) {
        this.openUpdateEmailModal(event.ID, event.Name, event.BCMailBox, event.IsDeloitte);
    }

  updateListData(event) {
      //used method
    }

    relaodSavedCountry() {
        const savedCountry = this.masterDataService.countryForManageMailBox;
        this.selectedCountry = savedCountry ? savedCountry : 'Country_Location';
        this.getFilteredCountryList(this.selectedCountry);
    }


    ngOnDestroy() {
        this.subscription.next();
        this.subscription.complete();
    }

}
